// The catalog rotation seed (catalog ordering step B, owner 2026-10-03).
//
// browse_products orders the catalog by a weighted random draw fixed by this
// seed: "<viewer>:<YYYY-MM-DD in Riyadh>:<visit>". So
//   • two traders see different orders (different viewer),
//   • every PAGE LOAD gets a new order (owner, 2026-10-11: "every time the
//     trader refreshes the page, the products change"). The seed lives in
//     memory for the life of the page, so paging and moving between screens
//     inside one load never repeat a product, even across midnight; a refresh
//     or a new tab draws again. (Earlier the same day it was pinned in
//     sessionStorage, which survives a refresh — the owner refreshed and saw
//     the same products. Before that it was one order per trader per day.)
// A signed-in viewer is their user id; a visitor is a random device id kept in
// localStorage. If storage is blocked, the visitor falls back to a shared id —
// still rotated daily, just the same order as other blocked visitors.
// Mirrors the mobile repo's src/lib/catalogSeed.js.
const DEVICE_KEY = 'maabar_device_id';
let pageSeed = null;   // this page load's seed

// Tests only: simulate a new page load.
export function resetCatalogSeedForTests() { pageSeed = null; }

// Riyadh is UTC+3 all year (no DST).
export function riyadhDate(now = new Date()) {
  return new Date(now.getTime() + 3 * 3600 * 1000).toISOString().slice(0, 10);
}

function deviceId() {
  try {
    let id = window.localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
      window.localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return 'shared';
  }
}

function visitId() {
  return Math.random().toString(36).slice(2, 10);
}

export function catalogSeed(userId, now = new Date()) {
  const viewer = userId ? `u:${userId}` : `d:${deviceId()}`;
  // Same viewer → keep this page load's seed. A sign-in mid-load is a new
  // viewer and gets their own order.
  if (pageSeed && pageSeed.startsWith(`${viewer}:`)) return pageSeed;
  pageSeed = `${viewer}:${riyadhDate(now)}:${visitId()}`;
  return pageSeed;
}
